import React, { Component } from 'react';
import { Link } from "react-router-dom";

export class Campaigns extends Component {
    constructor(props) {
        super(props);
        this.state = { campaigns: null, loading: true };
    }

    componentDidMount() {
        this.fetchCampaigns();
    }

    static renderCampaigns(campaigns) {
        return (
            <table className='table table-striped' aria-labelledby="tableLabel">
                <thead>
                    <tr>
                        <th>Id</th>
                        <th>Name</th>
                        <th>Description</th>
                        <th>Destination URL Template</th>
                    </tr>
                </thead>
                <tbody>
                    {campaigns.map(campaign =>
                        <tr key={campaign.id}>
                            <td><Link to={'/campaign/' + campaign.id + "?diags=true"}>{campaign.id}</Link></td>
                            <td><Link to={'/campaign/' + campaign.id + "?diags=true"}>{campaign.name}</Link></td>
                            <td>{campaign.description}</td>
                            <td>{campaign.destinationUrlTemplate}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : Campaigns.renderCampaigns(this.state.campaigns);

        return (
            <div>
                <h1 id="tableLabel" >Campaigns</h1>
                {contents}
            </div>
        );
    }

    async fetchCampaigns() {
        const response = await fetch('/api/campaign');
        const data = await response.json();
        this.setState({ campaigns: data, loading: false });
    }
}
